import { Box } from "@mui/material"
import React, { useMemo } from "react"
import { ResponsiveBar } from "@nivo/bar"
import { BarDatum } from "@nivo/bar/dist/types/types"
import { displayDecimal } from "../../../core/services/helper-service"

export interface IDataRowStackedBar {
  values: Record<string, number> // ficheId to carbon impact per surface
}

interface IProps {
  data: IDataRowStackedBar
  maxValue: number
  minValue: number
  width?: string
}

export function RowStackedBarChart({ data, maxValue, minValue, width = "100px" }: Readonly<IProps>): React.JSX.Element {
  const datum: BarDatum = useMemo(() => ({ index: "", ...data.values }), [data])
  const keys = useMemo(() => Object.keys(data.values), [data])

  return (
    <Box sx={{ height: "30px", width }}>
      {/* Hide the Responsive bar for positive value close to 0, it's an optimisation because rendering 100 charts is slow
      and when the value is close to 0, the chart is almost invisible anyway */}
      <ResponsiveBar
        data={[datum]}
        indexBy="index"
        keys={keys}
        margin={{}}
        padding={0}
        layout="horizontal"
        valueScale={{ type: "linear" }}
        maxValue={maxValue}
        minValue={minValue}
        labelSkipWidth={23}
        valueFormat={(v: string | number) => {
          if (typeof v === "number") {
            return displayDecimal(v, 1)
          } else {
            return v
          }
        }}
        enableGridY={false}
        legends={[]}
        axisTop={null}
        axisRight={null}
        axisBottom={null}
        axisLeft={null}
        animate={false}
        isInteractive={false}
      />
    </Box>
  )
}
